import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from 'moment';

const FirstPageGSTPurchaseEntry = (props) => {
    return (
        <>
            {/* 1. Item Search  */}
            <div className="item-search">
                <div className="item-grp flex gap-2.5 mb-2.5 w-[60%]">
                    <div className="search-grp w-[60%]">
                        <label>Party Name</label>
                        <input
                            type="text"
                            id="partyName"
                            name="partyName"
                            className="inputFocus w-full"
                            autocomplete="off"
                            value={props.filterDetails.partyName}
                            onChange={(event) =>
                                props.handleChange(event, "partyName", "filterDetails")
                            }
                        />
                    </div>

                    <div className="search-grp w-[40%]">
                        <label>Arranged By</label>
                        <select
                            name="arrangedBy"
                            className="w-full"
                            value={props.filterDetails.arrangedBy}
                            onChange={(event) =>
                                props.handleDropDownChange(
                                    event,
                                    "arrangedBy",
                                    "filterDetails"
                                )
                            }
                        >
                            <option>Select</option>
                            {props.arrangedByList.map((x, key) => (
                                <option key={key} value={x.value}>
                                    {x.arrangedBy}
                                </option>
                            ))}
                        </select>
                    </div>

                </div>
                <button className="add-btn" onClick={props.getGSTPurchseEntrySRNo}>
                    Add New
                </button>
            </div>

            {/* 2. Item tabel  */}
            <div className="itemList-table">
                <div className="table-container" style={{ height: "calc(100vh - 180px)" }}>
                    <table className="itemList">
                        <thead>
                            <tr>
                                <td className='w-[15%]'>Sr. No</td>
                                <td className='w-[15%]'>Inv. No</td>
                                <td className='w-[15%]'>Inv.Date</td>
                                <td className='w-[22%]'>Party Name</td>
                                <td className='w-[18%]'>Net Amount</td>
                                <td className='w-[15%] !text-center'>Action</td>
                            </tr>
                        </thead>

                        {props.gstPurchaseEntryRMPMList && props.gstPurchaseEntryRMPMList.length > 0
                            ? props.gstPurchaseEntryRMPMList.map((item, key) => (
                                <tbody key={key}>
                                    <tr>
                                        <td>{item.srNo}</td>
                                        <td>{item.invoiceNo}</td>
                                        <td>{moment(item.invoiceDate).format('DD MMM yyyy')}</td>
                                        <td>{item.partyName}</td>
                                        <td>{Number(item.grandTotal).toFixed(2)}</td>
                                        <td className='!text-center'>
                                            <button
                                                className="search-btn"
                                                onClick={() => props.getGSTPurchaseEntryRMPMById(item._id)}
                                            >
                                                <FontAwesomeIcon icon={faPen} />
                                            </button>
                                            <button
                                                className="cancel-btn"
                                                onClick={() => props.deleteGSTPurchaseEntryRMPMById(item._id)}
                                            >
                                                <FontAwesomeIcon icon={faTrash} />
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            ))
                            : props.gstPurchaseEntryRMPMList
                                && props.gstPurchaseEntryRMPMList.length === 0
                                && props.tableStatus !== "" ? (
                                <tr>
                                    <td colSpan={6} style={{ textAlign: "center", fontSize: "16px" }}>
                                        {props.tableStatus}
                                    </td>
                                </tr>
                            ) : props.gstPurchaseEntryRMPMList
                                && props.gstPurchaseEntryRMPMList.length === 0
                                && props.tableStatus === "" ? null : ""}

                    </table>
                </div>
            </div>
        </>
    );
};

export default FirstPageGSTPurchaseEntry;